<mat-card>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
        <mat-tab label="{{'PROFILE' | translate }}">
            <mat-card-content>
                <div class="row" [formGroup]="userForm">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'NAME' | translate}}</mat-label>
                            <input matInput type="text" placeholder="Full Name" formControlName="name">
                            @if (uf['name'].errors) {
                                <mat-error>
                                    @if (uf['name'].errors['required']) { <span>{{'FULL_NAME_REQUIRED' | translate}}</span>}
                                    @if (uf['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'CNIC' | translate}}</mat-label>
                            <input matInput formControlName="cnic">
                            @if (uf['cnic'].errors) {
                                <mat-error>
                                    @if (uf['cnic'].errors['required']) { <span>{{'FIELD_REQUIRED' | translate}}</span>}
                                    @if (uf['cnic'].errors['pattern']) { <span>{{'CNIC_PATTERN' | translate}}</span>}
                                    @if (uf['cnic'].errors['minlength'] || uf['cnic'].errors['maxlength']) { <span>{{'MINLENGTH_13' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div> -->
                    <div class="col-md-6">
                        <ngx-intl-tel-input
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            customPlaceholder="Phone"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                            [selectFirstCountry]="true"
                            [selectedCountryISO]="CountryISO.Pakistan"
                            [maxLength]="20"
                            [phoneValidation]="true"
                            [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National"
                            formControlName="mobile"
                            class="custom-control custom-phone-input"
                        >
                        </ngx-intl-tel-input>
                        @if (uf['mobile'].errors) {
                            <div class="text-danger">
                                @if (uf['mobile'].errors['required']) { <span>{{'MOBILE_REQUIRED' | translate}}</span>}
                                @if (uf['mobile'].errors['pattern'] || uf['mobile'].errors['maxlength'] || uf['mobile'].errors['maxlength']) { <span>{{'MAX_LENGTH_20' | translate}}</span>}
                            </div>
                        }
                        <!-- <mat-form-field appearance="outline">
                            <mat-label>{{'PHONE_NUMBER' | translate}}</mat-label>
                            <input matInput formControlName="mobile" maxlength="11">
                            @if (uf['mobile'].errors) {
                                <mat-error>
                                    @if (uf['mobile'].errors['required']) { <span>{{'MOBILE_REQUIRED' | translate}}</span>}
                                    @if (uf['mobile'].errors['pattern'] || uf['mobile'].errors['maxlength'] || uf['mobile'].errors['maxlength']) { <span>{{'MAX_LENGTH_20' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field> -->
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'EMAIL' | translate}}</mat-label>
                            <input matInput type="email" placeholder="Email" formControlName="email">
                            @if (uf['email'].errors) {
                                <mat-error>
                                    @if (uf['email'].errors['required']) { <span>{{'EMAIL_REQUIRED' | translate}}</span>}
                                    @if (uf['email'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
                                    @if (uf['email'].errors['email']) { <span>{{'INVALID_EMAIL' | translate}}</span>}
                                    @if (uf['email'].errors['pattern']) { <span>{{'INVALID_EMAIL' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'GENDER' | translate}}</mat-label>
                            <mat-select formControlName="gender">
                                <mat-option [value]="'Male'">Male</mat-option>
                                <mat-option [value]="'Female'">Female</mat-option>
                                <mat-option [value]="'Transgender Person'">Transgender Person</mat-option>
                            </mat-select>
                            @if (uf['gender'].errors) {
                                <mat-error>
                                    @if (uf['gender'].errors['required']) { <span>{{'FIELD_REQUIRED' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-12">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'ADDRESS' | translate}}</mat-label>
                            <textarea matInput formControlName="address" size="large"></textarea>
                            @if (uf['address'].errors) {
                                <mat-error>
                                    @if (uf['address'].errors['required']) { <span>{{'ADDRESS_REQUIRED' | translate}}</span>}
                                    @if (uf['address'].errors['maxlength']) { <span>{{'MAX_LENGTH_200' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>

                <mat-card-actions align="end">
                    <button mat-raised-button color="primary" (click)="saveUser()" [disabled]="userForm.invalid">{{'SAVE' | translate}}</button>
                </mat-card-actions>
            </mat-card-content>
        </mat-tab>
        <mat-tab label="{{'SECURITY' | translate }}">
            <mat-card-content [formGroup]="changePasswordForm" >
                <h4>{{ 'CHANGE_PASSWORD' | translate }}</h4>
                <div class="row">
                    <!-- <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'CURRENT_PASSWORD' | translate}}</mat-label>
                            <input matInput type="password" formControlName="password">
                            @if (pf['password'].errors) {
                                <mat-error>
                                    @if (pf['password'].errors['required']) { <span>{{'PASSWORD_REQUIRED' | translate}}</span>}
                                    @if (pf['password'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                                    @if (pf['password'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                                    @if (pf['password'].errors['minlength']) { <span>{{'MINLENGTH_8' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div> -->
                </div>
                <div class="row" >
                    <div class="col-md-6" >
                        <mat-form-field appearance="outline">
                            <mat-label>{{'NEW_PASSWORD' | translate}}</mat-label>
                            <input matInput type="password" formControlName="newPassword">
                            @if (pf['newPassword'].errors) {
                                <mat-error>
                                    @if (pf['newPassword'].errors['required']) { <span>{{'PASSWORD_REQUIRED' | translate}}</span>}
                                    @if (pf['newPassword'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                                    @if (pf['newPassword'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                                    @if (pf['newPassword'].errors['minlength']) { <span>{{'MINLENGTH_8' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'CONFIRM_PASSWORD' | translate}}</mat-label>
                            <input matInput type="password" formControlName="confirmPassword">
                            @if (pf['confirmPassword'].errors) {
                                <mat-error>
                                    @if (pf['confirmPassword'].errors['required']) { <span>{{'PASSWORD_REQUIRED' | translate}}</span>}
                                    @if (pf['confirmPassword'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                                    @if (pf['confirmPassword'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                                    @if (pf['confirmPassword'].errors['minlength']) { <span>{{'MINLENGTH_8' | translate}}</span>}
                                    @if (pf['confirmPassword'].errors['matchPassword']) { <span>{{'MATCH_PASSWORD' | translate}}</span>}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>

                <mat-card-actions align="end">
                    <button mat-raised-button color="primary" (click)="sendCode()" [disabled]="changePasswordForm.invalid">{{'SEND_OTP' | translate}}</button>
                </mat-card-actions>

            </mat-card-content>
        </mat-tab>
    </mat-tab-group>

</mat-card>